/**
 * The hand that appears on the world map and points at the bubble gifts or level nodes
 */
export default class MapTutHand extends G.Image {
  /**
   * MapTutHand is created first to secure layer order
   * @param {WorldMap} map
   */
  constructor(map) {
    super(0, 0, 'tut_hand', 0);
    this.map = map;
    this.positionIsSet = false;
    this.visible = false;

    game.add.tween(this.anchor) // Pointy
      .to({ x: -0.1, y: -0.1 }, 500, Phaser.Easing.Sinusoidal.InOut, true, 0, -1, true);

    game.add.existing(this);
  }

  /**
   * Repositioning happens here as it calculates where it should go
   */
  reposition() {
    const lastPassed = G.saveState.getLastPassedLevelNr();
    const levelData = G.Helpers.levelDataMgr.getLevelByIndex(lastPassed);
    if (levelData) {
      this._levelPos = { // Level pos is set to the level node
        x: levelData.mapX,
        y: levelData.mapY,
      };
    }
    // Gets Gate position (into levelPos);
    if (lastPassed === G.Helpers.gatesMgr.getFirstClosedGateLvLIndex()) {
      this._levelPos.y += 35;
    }

    // Find the closest bubble and target it
    const closestBubbleLevelNumber = G.Helpers.bubbleGiftsMgr.getUnopenedBubblesLevels()
      .find((levelNumber) => levelNumber - 1 <= lastPassed && Math.abs(lastPassed - levelNumber) < 2);
    let bubblePos;
    if (closestBubbleLevelNumber) {
      const targetBubble = this.map.getClosestBubblePositionTo(closestBubbleLevelNumber); // Uses same algorithm as G.WorldMapBubbleGiftDynamicLayer, given by WorldMap
      if (targetBubble) {
        this._bubbleLvlNr = closestBubbleLevelNumber;
        bubblePos = targetBubble;
      }
    }

    this.visible = true;
    if (closestBubbleLevelNumber && bubblePos) { // Prioritize the bubble for the hand
      this.position.setTo(bubblePos.x, bubblePos.y);
      G.sb('onBubbleGiftOpened').add(this._onBubbleGiftOpened, this);
      this._showingBubble = true;
    } else if (this._levelPos) { // then the level pos
      this.position.setTo(this._levelPos.x, this._levelPos.y);
    } else { // Or don't show it
      this.visible = false;
    }
    this.positionIsSet = true;
  }

  /**
   * Once the bubble is opened, tween to the level pos
   * @param {number} lvlNumber
   */
  _onBubbleGiftOpened(lvlNumber) {
    if (!this._showingBubble) return;
    if (this._bubbleLvlNr === lvlNumber) {
      if (this._levelPos) {
        this._showingBubble = false;
        game.add.tween(this).to({
          x: this._levelPos.x,
          y: this._levelPos.y,
        }, 300, Phaser.Easing.Sinusoidal.InOut, true);
      } else {
        game.add.tween(this).to({ alpha: 0 }, 300, Phaser.Easing.Sinusoidal.InOut, true);
      }
    }
  }
}
